import React, { useState, useEffect } from 'react';

function Slideshow() {
  const images = [
    '/images/slides/FB_IMG_1761234205450.jpg',
    '/images/slides/FB_IMG_1761234210905.jpg',
    '/images/slides/FB_IMG_1761234214946.jpg',
    '/images/slides/FB_IMG_1761234222058.jpg',
    '/images/slides/FB_IMG_1761234237308.jpg',
    '/images/slides/FB_IMG_1761234240991.jpg',
    '/images/slides/FB_IMG_1761234248134.jpg',
    '/images/slides/FB_IMG_1761234252240.jpg',
    '/images/slides/FB_IMG_1761234265718.jpg',
    '/images/slides/FB_IMG_1761234280943.jpg',
    '/images/slides/FB_IMG_1761234291123.jpg',
    '/images/slides/FB_IMG_1761234294926.jpg',
    '/images/slides/FB_IMG_1761234307664.jpg',
    '/images/slides/FB_IMG_1761234317069.jpg',
    '/images/slides/FB_IMG_1761234324284.jpg',
    '/images/slides/FB_IMG_1761234327105.jpg',
    '/images/slides/FB_IMG_1761234338826.jpg',
    '/images/slides/FB_IMG_1761234344752.jpg',
    '/images/slides/FB_IMG_1761234348394.jpg',
    '/images/slides/FB_IMG_1761234351491.jpg',
    '/images/slides/FB_IMG_1761234357327.jpg',
    '/images/slides/FB_IMG_1761234361142.jpg',
    '/images/slides/FB_IMG_1761234371228.jpg',
    '/images/slides/FB_IMG_1761234375642.jpg',
    '/images/slides/FB_IMG_1761234385165.jpg',
    '/images/slides/FB_IMG_1761234398724.jpg',
    '/images/slides/FB_IMG_1761234402710.jpg',
    '/images/slides/FB_IMG_1761234406378.jpg',
    '/images/slides/FB_IMG_1761234412281.jpg',
    '/images/slides/FB_IMG_1761234416657.jpg',
    '/images/slides/FB_IMG_1761234419497.jpg',
    '/images/slides/FB_IMG_1761234422363.jpg',
    '/images/slides/FB_IMG_1761234425023.jpg',
    '/images/slides/FB_IMG_1761234431417.jpg',
    '/images/slides/FB_IMG_1761234437708.jpg',
    '/images/slides/FB_IMG_1761234442493.jpg',
    '/images/slides/FB_IMG_1761234454483.jpg',
    '/images/slides/FB_IMG_1761234466092.jpg'
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="slideshow">
      <button className="prev" onClick={goToPrevious}>&#10094;</button>
      <img src={images[currentIndex]} alt="Slideshow" />
      <button className="next" onClick={goToNext}>&#10095;</button>
      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default Slideshow;